module.exports = __webpack_public_path__ + "img/compass.0184eb1.svg";